
import request from '@/router/axios';

const baseUrl = "/ds_device"

// 设备概况
export const overview = () => request({
    url: baseUrl+ '/overview',
    method: 'get'
});

// 最新动态
export const latest_news = () => request({
    url: baseUrl+ '/info/latest',
    method: 'get'
});

// 设备预约排行
export const reserve_rank = () => request({
    url: baseUrl+ '/reserve/rank',
    method: 'get'
});

// 设备预约趋势(近七天)
export const reserve_trend = () => request({
    url: baseUrl+ '/reserve/trend',
    method: 'get'
});

// 设备核心指标趋势(近30天)
export const core_trend = () => request({
    url: baseUrl+ '/core/trend',
    method: 'get'
});



// 设备列表
export const list = (params) => request({
    url: baseUrl+ '/list',
    method: 'get',
    params: params
});


export const audit = (obj) => request({
    url: baseUrl + '/audit',
    method: 'post',
    data: obj
});

export const detail = (id) => request({
    url: baseUrl+ '/detail/'+id,
    method: 'get',
});

